"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  DataTransferSquareVertical: ['data-transfer-square-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.043,0H1.957A1.959,1.959,0,0,0,0,1.956V22.044A1.959,1.959,0,0,0,1.957,24H22.043A1.959,1.959,0,0,0,24,22.044V1.956A1.959,1.959,0,0,0,22.043,0ZM5.75,9.5a.749.749,0,0,1-.6-1.2L7.9,4.634a.78.78,0,0,1,1.2,0L11.85,8.3a.75.75,0,0,1-.6,1.2H9.75a.25.25,0,0,0-.25.25V16.5a1,1,0,0,1-2,0V9.75a.25.25,0,0,0-.25-.25Zm12.5,5a.749.749,0,0,1,.6,1.2L16.1,19.366a.75.75,0,0,1-1.2,0L12.15,15.7a.75.75,0,0,1,.6-1.2h1.5a.25.25,0,0,0,.25-.25V7.5a1,1,0,0,1,2,0v6.75a.25.25,0,0,0,.25.25Z']],
  DataTransferSquareDiagonalAlternate: ['data-transfer-square-diagonal-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.182,11.646,11.824,15a.25.25,0,0,1-.353,0l-.71-.71a.75.75,0,0,0-1.271.428l-.648,4.536a.749.749,0,0,0,.746.856.889.889,0,0,0,.1-.006l4.539-.649a.749.749,0,0,0,.422-1.272l-.707-.708a.249.249,0,0,1,0-.353L17.3,13.767a1.5,1.5,0,0,0-2.121-2.121Z', 'M22.044,0H1.957A1.959,1.959,0,0,0,0,1.955V22.043A1.959,1.959,0,0,0,1.957,24H22.044A1.959,1.959,0,0,0,24,22.043V1.955A1.959,1.959,0,0,0,22.044,0ZM2,21.041V3A1,1,0,0,1,3,2l18-.04a1,1,0,0,1,1,1L22.041,21a1,1,0,0,1-1,1L3,22.041A1,1,0,0,1,2,21.041Z', 'M13.239,9.7a.75.75,0,0,0,.528.216.765.765,0,0,0,.239-.038.746.746,0,0,0,.5-.606l.648-4.536a.751.751,0,0,0-.849-.849l-4.538.648a.751.751,0,0,0-.423,1.273l.708.707a.252.252,0,0,1,0,.354L6.7,10.232a1.5,1.5,0,0,0,2.121,2.121l3.358-3.359a.251.251,0,0,1,.354,0Z']],
  DataTransferDiagonal1: ['data-transfer-diagonal-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.811,13.627,13.958,6.48a.247.247,0,0,1,.353,0l.884.884a1,1,0,0,0,.707.293,1.016,1.016,0,0,0,.267-.036,1,1,0,0,0,.7-.722l1.414-5.657A1,1,0,0,0,17.074.03L11.417,1.444a1,1,0,0,0-.464,1.677l.884.884a.249.249,0,0,1,0,.353L4.689,11.506a1.5,1.5,0,0,0,2.122,2.121Z', 'M17.189,10.373,10.042,17.52a.25.25,0,0,1-.353,0l-.884-.885a1,1,0,0,0-1.678.465L5.713,22.758A1,1,0,0,0,6.683,24a.964.964,0,0,0,.243-.031l5.657-1.414a1,1,0,0,0,.464-1.676L12.163,20a.25.25,0,0,1,0-.354l7.148-7.147a1.5,1.5,0,1,0-2.122-2.121Z']],
  DataTransfer: ['data-transfer', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.854.276A.5.5,0,0,0,17,.629v1.75a.25.25,0,0,1-.25.25H7.88A5.882,5.882,0,0,0,2,8.5a5.74,5.74,0,0,0,.921,3.142.5.5,0,0,0,.419.228.534.534,0,0,0,.069,0,.5.5,0,0,0,.408-.347A4.154,4.154,0,0,1,7.76,8.629h8.99a.25.25,0,0,1,.25.25v1.75a.5.5,0,0,0,.854.354l5-5a.5.5,0,0,0,0-.707Z', 'M16.24,15.37H7.25A.25.25,0,0,1,7,15.12V13.37a.5.5,0,0,0-.854-.354l-5,5a.5.5,0,0,0,0,.707l5,5a.5.5,0,0,0,.354.147.512.512,0,0,0,.191-.038A.5.5,0,0,0,7,23.37V21.62a.25.25,0,0,1,.25-.25h8.87A5.882,5.882,0,0,0,22,15.5a5.741,5.741,0,0,0-.921-3.143.508.508,0,0,0-.488-.223.5.5,0,0,0-.408.347A4.154,4.154,0,0,1,16.24,15.37Z']],
  DataTransferCircle: ['data-transfer-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8.924,12.094A1,1,0,0,1,9.5,13v1.25a.25.25,0,0,0,.25.25H13.5a1,1,0,0,1,0,2H9.75a.25.25,0,0,0-.25.25V18a1,1,0,0,1-1.64.768l-3-2.5a1,1,0,0,1,0-1.537l3-2.5A1,1,0,0,1,8.924,12.094ZM15.5,12a1,1,0,0,1-1-1V9.75a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h3.75a.25.25,0,0,0,.25-.25V6a1,1,0,0,1,1.64-.769l3,2.5a1,1,0,0,1,0,1.537l-3,2.5A1,1,0,0,1,15.5,12Z']],
  DataTransferDiagonal: ['data-transfer-diagonal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.373,19.31a1.5,1.5,0,0,0,2.121,0l7.147-7.147a.25.25,0,0,1,.354,0l.884.883a1,1,0,0,0,.707.293.976.976,0,0,0,.267-.036,1,1,0,0,0,.7-.722L23.97,6.925a1,1,0,0,0-1.213-1.212L17.1,7.127A1,1,0,0,0,16.636,8.8l.884.884a.25.25,0,0,1,0,.353l-7.147,7.148A1.5,1.5,0,0,0,10.373,19.31Z', 'M11.538,4.659,4.146,11.634a.249.249,0,0,1-.348-.005l-.677-.676a1,1,0,0,0-1.677.464L.03,17.074A1,1,0,0,0,1,18.316a1.01,1.01,0,0,0,.243-.03L6.9,16.872A1,1,0,0,0,7.364,15.2l-1.091-1.09a.254.254,0,0,1-.073-.181.247.247,0,0,1,.079-.178L13.6,6.84a1.5,1.5,0,1,0-2.058-2.181Z']],
  DataTransferHorizontal: ['data-transfer-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6,10.231a1,1,0,0,0,1-1V7.981a.25.25,0,0,1,.25-.25H17.358a1.5,1.5,0,0,0,0-3H7.25A.25.25,0,0,1,7,4.481V3.231a1,1,0,0,0-1.515-.857l-5,3a1,1,0,0,0,0,1.715l5,3A1,1,0,0,0,6,10.231Z', 'M23.515,16.911l-5-3A1,1,0,0,0,17,14.769v1.25a.25.25,0,0,1-.25.25H6.642a1.5,1.5,0,1,0,0,3H16.75a.249.249,0,0,1,.25.25v1.25a1,1,0,0,0,1.515.857l5-3a1,1,0,0,0,0-1.715Z']],
  DataTransferFtp: ['data-transfer-ftp', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M11.5,5.5a1,1,0,0,0,1-1V3.75a.25.25,0,0,1,.25-.25H14a.5.5,0,0,0,.354-.854l-2.5-2.5a.5.5,0,0,0-.708,0l-2.5,2.5A.5.5,0,0,0,9,3.5h1.25a.25.25,0,0,1,.25.25V4.5A1,1,0,0,0,11.5,5.5Z', 'M17.25,10.25a.25.25,0,0,0-.25.25v1a.25.25,0,0,0,.25.25h.5a.75.75,0,0,0,0-1.5Z', 'M2,8v8a1.5,1.5,0,0,0,1.5,1.5h17A1.5,1.5,0,0,0,22,16V8a1.5,1.5,0,0,0-1.5-1.5H3.5A1.5,1.5,0,0,0,2,8ZM15.5,9.5a.75.75,0,0,1,.75-.75h1.5a2.25,2.25,0,0,1,0,4.5h-.5a.25.25,0,0,0-.25.25v1a.75.75,0,0,1-1.5,0Zm-4.75.75a.75.75,0,0,1,0-1.5h3a.75.75,0,0,1,0,1.5h-.5a.25.25,0,0,0-.25.25v4a.75.75,0,0,1-1.5,0v-4a.25.25,0,0,0-.25-.25Zm-3.5,1a.75.75,0,0,1,0,1.5h-1A.25.25,0,0,0,6,13v1.5a.75.75,0,0,1-1.5,0v-4A1.752,1.752,0,0,1,6.25,8.75h2a.75.75,0,0,1,0,1.5h-2A.25.25,0,0,0,6,10.5V11a.25.25,0,0,0,.25.25Z', 'M11.5,18.5a1,1,0,0,0-1,1v.75a.25.25,0,0,1-.25.25H9a.5.5,0,0,0-.354.853l2.5,2.5a.5.5,0,0,0,.708,0l2.5-2.5A.5.5,0,0,0,14,20.5H12.75a.25.25,0,0,1-.25-.25V19.5A1,1,0,0,0,11.5,18.5Z']],
  DataTransferSquareDiagonal: ['data-transfer-square-diagonal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.043,0H1.957A1.959,1.959,0,0,0,0,1.956V22.044A1.959,1.959,0,0,0,1.957,24H22.043A1.959,1.959,0,0,0,24,22.044V1.956A1.959,1.959,0,0,0,22.043,0ZM14.652,18.187a.751.751,0,0,1-.423,1.273l-4.538.648a.713.713,0,0,1-.1.007.75.75,0,0,1-.746-.856l.648-4.537a.751.751,0,0,1,1.271-.427l1.063,1.063a.25.25,0,0,0,.353,0L15.536,12a1,1,0,0,1,1.414,1.414l-3.359,3.358a.25.25,0,0,0,0,.354ZM9.348,5.812A.75.75,0,0,1,9.771,4.54l4.538-.649a.748.748,0,0,1,.637.213.758.758,0,0,1,.212.637L14.51,9.277a.749.749,0,0,1-.5.606.765.765,0,0,1-.239.038.753.753,0,0,1-.528-.216L12.176,8.641A.252.252,0,0,0,12,8.568a.249.249,0,0,0-.177.073L8.464,12A1,1,0,0,1,7.05,10.586l3.359-3.359a.25.25,0,0,0,0-.354Z']],
  DataTransferVerticalDiamond: ['data-transfer-vertical-diamond', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,10.586,13.415,1A1.983,1.983,0,0,0,12,.416h0A1.984,1.984,0,0,0,10.586,1L1,10.586a2,2,0,0,0,0,2.828L10.586,23a2.006,2.006,0,0,0,2.829,0L23,13.414A2,2,0,0,0,23,10.586Zm-7.97,3.83a.5.5,0,0,1,.353.853l-3,3a.5.5,0,0,1-.707,0l-3-3a.5.5,0,0,1,.354-.853h1.5a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H9.03a.5.5,0,0,1-.354-.854l3-3a.5.5,0,0,1,.707,0l3,3a.5.5,0,0,1-.353.854h-1.5a.25.25,0,0,0-.25.25v4.5a.25.25,0,0,0,.25.25Z']],
  DataTransferVertical: ['data-transfer-vertical', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.481,5.124a1.5,1.5,0,0,0-1.5,1.5V16.733a.249.249,0,0,1-.25.25H3.481A1,1,0,0,0,2.624,18.5l3,5a1,1,0,0,0,1.715,0l3-5a1,1,0,0,0-.858-1.514H8.231a.25.25,0,0,1-.25-.25V6.624A1.5,1.5,0,0,0,6.481,5.124Z', 'M17.519,18.84a1.5,1.5,0,0,0,1.5-1.5V7.233a.249.249,0,0,1,.25-.25h1.25a1,1,0,0,0,.857-1.515l-3-5a1.04,1.04,0,0,0-1.715,0l-3,5a1,1,0,0,0,.858,1.515h1.25a.25.25,0,0,1,.25.25V17.34A1.5,1.5,0,0,0,17.519,18.84Z']],
  DataTransferSquareVerticalAlternate: ['data-transfer-square-vertical-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.251,14.5h-1a.25.25,0,0,1-.25-.25V9.5a1.5,1.5,0,1,0-3,0v4.75a.25.25,0,0,1-.25.25h-1a.749.749,0,0,0-.6,1.2L14.9,19.367a.75.75,0,0,0,1.2,0L18.848,15.7a.749.749,0,0,0-.6-1.2Z', 'M24,1.955A1.959,1.959,0,0,0,22.044,0H1.957A1.959,1.959,0,0,0,0,1.955V22.043A1.959,1.959,0,0,0,1.957,24H22.044A1.959,1.959,0,0,0,24,22.043ZM2,21.041V3A1,1,0,0,1,3,2l18-.04a1,1,0,0,1,1,1L22.041,21a1,1,0,0,1-1,1L3,22.041A1,1,0,0,1,2,21.041Z', 'M9.1,4.631a.781.781,0,0,0-1.2,0L5.152,8.3a.749.749,0,0,0,.6,1.2h1a.25.25,0,0,1,.25.25V14.5a1.5,1.5,0,1,0,3,0V9.749a.25.25,0,0,1,.25-.25h1a.749.749,0,0,0,.6-1.2Z']],
  DataTransferSquareHorizontal: ['data-transfer-square-horizontal', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.043,0H1.957A1.959,1.959,0,0,0,0,1.956V22.044A1.959,1.959,0,0,0,1.957,24H22.043A1.959,1.959,0,0,0,24,22.044V1.956A1.959,1.959,0,0,0,22.043,0ZM14.5,14.5h2a1,1,0,0,1,0,2H9.75a.25.25,0,0,0-.25.25v1.5a.749.749,0,0,1-1.2.6L4.634,16.1a.75.75,0,0,1,0-1.2L8.3,12.152a.749.749,0,0,1,1.2.6v1.5a.25.25,0,0,0,.25.25Zm1.2-2.653A.743.743,0,0,1,15.25,12a.76.76,0,0,1-.334-.078.75.75,0,0,1-.416-.672V9.75a.25.25,0,0,0-.25-.25H7.5a1,1,0,0,1,0-2h6.75a.25.25,0,0,0,.25-.25V5.75a.75.75,0,0,1,1.2-.6L19.366,7.9a.75.75,0,0,1,0,1.2Z']],
  DataTransferThreeBackForthBack: ['data-transfer-three-back-forth-back', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.542,10.527H8.9a.25.25,0,0,1-.25-.25V9.089a.959.959,0,0,0-1.452-.821L2.4,11.143a.957.957,0,0,0,0,1.643l4.791,2.875a.959.959,0,0,0,1.452-.822V13.652a.25.25,0,0,1,.25-.25H22.542a1.438,1.438,0,0,0,0-2.875Z', 'M.021,4.333A1.437,1.437,0,0,0,1.458,5.771H15.1a.25.25,0,0,1,.25.25V7.208a.958.958,0,0,0,1.452.822L21.6,5.155a.957.957,0,0,0,0-1.643L16.806.637a.958.958,0,0,0-1.452.821V2.646a.25.25,0,0,1-.25.25H1.458A1.437,1.437,0,0,0,.021,4.333Z', 'M21.6,18.845,16.806,15.97a.959.959,0,0,0-1.452.822v1.187a.25.25,0,0,1-.25.25H1.458a1.438,1.438,0,0,0,0,2.875H15.1a.25.25,0,0,1,.25.25v1.188a.958.958,0,0,0,1.452.821L21.6,20.488a.957.957,0,0,0,0-1.643Z']],
  DataTransferSquareHorizontalAlternate: ['data-transfer-square-horizontal-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.7,5.148a.75.75,0,0,0-1.2.6v1a.25.25,0,0,1-.25.25H9.5a1.5,1.5,0,0,0,0,3h4.75a.25.25,0,0,1,.25.25v1a.75.75,0,0,0,1.2.6L19.364,9.1a.75.75,0,0,0,0-1.2Z', 'M22.044,0H1.957A1.959,1.959,0,0,0,0,1.955V22.043A1.959,1.959,0,0,0,1.957,24H22.044A1.959,1.959,0,0,0,24,22.043V1.955A1.959,1.959,0,0,0,22.044,0ZM2,21,1.959,3a1,1,0,0,1,1-1L21,1.957a1,1,0,0,1,1,1L22.041,21a1,1,0,0,1-1,1H3A1,1,0,0,1,2,21Z', 'M14.5,14H9.751a.25.25,0,0,1-.25-.25v-1a.75.75,0,0,0-1.2-.6L4.636,14.9a.75.75,0,0,0,0,1.2L8.3,18.851A.752.752,0,0,0,8.751,19a.733.733,0,0,0,.334-.08.743.743,0,0,0,.416-.671v-1a.25.25,0,0,1,.25-.25H14.5a1.5,1.5,0,1,0,0-3Z']]
};
exports["default"] = _default;